// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__5X_Ae","colCheckbox":"styles_colCheckbox__OaUJ0"};